import { Link } from '@tanstack/react-router';
import { Pencil, LayoutDashboard } from 'lucide-react';
import { Button } from '@/components/ui/button';

/** Admin action bar shown to organizer admins above event content. */
export function AdminBar({
  eventId,
}: {
  eventId: string;
}) {
  return (
    <div className="bg-slate-900 text-white">
      <div className="max-w-5xl mx-auto px-4 py-2.5 flex items-center justify-between">
        <span className="text-sm font-medium">
          You manage this event
        </span>
        <div className="flex items-center gap-2">
          <Button
            size="sm"
            variant="outline"
            className="border-slate-600 text-white hover:bg-slate-800 h-8 text-xs"
            asChild
          >
            <Link
              to="/admin/dashboard/event/$eventId/edit"
              params={{ eventId }}
            >
              <Pencil className="w-3.5 h-3.5 mr-1.5" />
              Edit
            </Link>
          </Button>
          <Button
            size="sm"
            variant="outline"
            className="border-slate-600 text-white hover:bg-slate-800 h-8 text-xs"
            asChild
          >
            <Link
              to="/admin/dashboard/event/$eventId"
              params={{ eventId }}
            >
              <LayoutDashboard className="w-3.5 h-3.5 mr-1.5" />
              Dashboard
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
